
import { environment } from '../environments/environment';
import { AngularFirestore } from 'angularfire2/firestore';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

// Modulos
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { APP_ROUTING } from './app.routes';

// Material
import { MatInputModule, MatDialogModule, } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';

// Servicios
import { UserService } from '../services/user.service';
import { FirestoreService } from '../services/firestore/firestore.service';
import { AuthGuardService } from '../services/authguard.service';


// Componentes
import { AppComponent } from './app.component';
import { LoginComponent } from '../pages/login/login.component';
import { HomeComponent } from '../pages/home/home.component';
import { UsuariosComponent } from '../pages/usuarios/usuarios.component';
import { AlumnosComponent } from '../pages/alumnos/alumnos.component';
import { PlanificacionesComponent } from '../pages/planificaciones/planificaciones.component';
import { NavBarComponent } from '../shared/nav-bar.component';
import { EvaluacionesComponent } from 'src/pages/evaluaciones/evaluaciones.component';

// Paginacion
import { NgxPaginationModule } from 'ngx-pagination';
import { EvaluacionGeneralComponent } from 'src/pages/evaluaciones/evalucionGeneral/evaluacionGeneral.component';
import { InformeAlumnoComponent } from 'src/pages/informe/informeAlumno/informe-alumno.component';
import { InformeCursoComponent } from 'src/pages/informe/informeCurso/informe-curso.component';

//print
import {NgxPrintModule} from 'ngx-print';

@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    LoginComponent,
    AlumnosComponent,
    UsuariosComponent,
    HomeComponent,
    PlanificacionesComponent,
    EvaluacionesComponent,
    EvaluacionGeneralComponent,
    InformeAlumnoComponent,
    InformeCursoComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    APP_ROUTING,
    SweetAlert2Module.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    NgxPaginationModule,
    MatInputModule,
    MatDialogModule,
    MatAutocompleteModule,
    NgxPrintModule,
    MatDatepickerModule,        // <----- import(must)
    MatNativeDateModule,        // <----- import for date formating(optional)
  ],
  entryComponents: [
    EvaluacionGeneralComponent
  ],
  exports: [
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [
    FirestoreService,
    AngularFirestore,
    AuthGuardService,
    UserService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
